import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { AuthenticatorChangeSuccessComponent } from './authenticator-change-success.component';



@NgModule({
  declarations: [
    AuthenticatorChangeSuccessComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule
  ]
})
export class AuthenticatorChangeSuccessModule { }
